import { createRoot } from 'react-dom/client';
import { BlogHero } from '@/components/blog/BlogHero';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { LandingNav } from '@/components/landing/LandingNav';
import { ArticleCard } from '@/components/ui/blog-post-card';
import { INSIGHTS_POSTS } from '@/data/insights-posts';
import './styles.css';
import './landing.css';
import '@/tailwind.css';

function InsightsPage() {
  return (
    <div id="tc-page" className="tc-page min-h-screen w-full overflow-x-clip bg-white font-sans text-neutral-900">
      <LandingNav />
      <main className="w-full">
        <BlogHero />

        <section className="w-full border-t border-neutral-100 px-4 py-12 sm:px-6 md:py-20 lg:px-8">
          <div className="mx-auto w-full max-w-7xl">
            <div className="mb-8 w-full max-w-xl md:mb-10">
              <p className="mb-2 text-sm font-medium uppercase tracking-wide text-neutral-500">Latest</p>
              <h2 className="text-2xl font-semibold text-neutral-900 md:text-3xl">
                Guides for South African decision-makers
              </h2>
              <p className="mt-3 text-neutral-600">
                Pricing, scope, and delivery expectations, explained without the agency fluff.
              </p>
            </div>

            <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8">
              {INSIGHTS_POSTS.map((post) => (
                <ArticleCard key={post.href} {...post} />
              ))}
            </div>

            <p className="mx-auto mt-12 max-w-2xl text-center text-sm text-neutral-500">
              More insights are publishing soon across cost & pricing, business systems, and industry guides.
            </p>
          </div>
        </section>
      </main>
      <LandingFooter />
    </div>
  );
}

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(<InsightsPage />);
}
